import React from 'react';
import { Check, CheckCheck, Eye, PenLine } from 'lucide-react';
import { HaekchenStufen } from '../HaekchenStufen';

// Häkchen wie bei WhatsApp: gesendet → zugestellt → geöffnet → unterschrieben
export const SignaturHaekchen = ({ h = {}, status, id }) => {
  const signiert = h.signiert_am || ['signiert', 'abgeschlossen'].includes(status);
  return (
    <HaekchenStufen testId={`sig-haekchen-${id}`} stufen={[
      ['gesendet', 'Gesendet', Check, h.gesendet_am || (status && status !== 'entwurf' ? (h.created_at || true) : null)],
      ['zugestellt', 'Zugestellt', CheckCheck, h.zugestellt_am || h.geoeffnet_am || h.dokument_angesehen_am],
      ['geoeffnet', 'Geöffnet', Eye, h.dokument_angesehen_am],
      ['unterschrieben', 'Unterschrieben', PenLine, signiert ? (h.signiert_am || true) : null],
    ]} />
  );
};

export default SignaturHaekchen;
